import React from 'react';
import { Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-[#050505] py-12 px-4 border-t border-gold/20" data-id="element-32">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-33">
        <div className="text-center md:text-left" data-id="element-34">
          <h2 className="font-display text-3xl font-bold text-white uppercase tracking-widest" data-id="element-35">
            Pueblo <span className="text-gold" data-id="element-36">Barber</span>
          </h2>
          <p className="text-muted mt-2" data-id="element-37">Sé tu mejor versión.</p>
        </div>

        <div className="flex flex-col items-center md:items-start text-center md:text-left space-y-2" data-id="element-38">
          <p className="text-muted" data-id="element-39">C.M Ramírez 1528 esq. Vigo</p>
          <a href="https://book.weibook.co/branch/pueblo-barber-sede-1" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-white transition-colors uppercase font-bold text-sm tracking-wider" data-id="element-40">
            Reservar Turno
          </a>
        </div>

        <div className="flex items-center space-x-4" data-id="element-41">
          <a href="https://instagram.com/pueblobarber" target="_blank" rel="noopener noreferrer" className="text-muted hover:text-gold transition-colors" aria-label="Instagram" data-id="element-42">
            <Instagram className="w-6 h-6" data-id="element-43" />
          </a>
        </div>
      </div>
      <div className="max-w-6xl mx-auto mt-12 pt-8 border-t border-[#222222] text-center text-muted text-sm" data-id="element-44">
        &copy; {new Date().getFullYear()} Pueblo Barber. Todos los derechos
        reservados.
      </div>
    </footer>;
}